"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onRecentKeyDown = exports.onAutoCompKeyDown = exports.onInputKeyDown = void 0;
const urlHandler_1 = require("../../../../modules/urlHandler");
// 방향키 이동 전의 원래 input 값을 저장
let savedInputValue = null;
let activeAutoIndex = -1;
let wasInKeywordArea = false;
const onInputKeyDown = ({ e, setFocus, setInputValue, }) => {
    if (e.nativeEvent.isComposing) {
        return;
    }
    const $input = document.querySelector('.Search__Input');
    if (!$input) {
        return;
    }
    if (e.code === "Escape") {
        const searchQuery = (0, urlHandler_1.getQueryParams)();
        setFocus(false);
        setInputValue(searchQuery.query ? searchQuery.query : "");
        activeAutoIndex = -1;
        savedInputValue = null;
        wasInKeywordArea = false;
        return;
    }
    // 유저 입력에 의한 값 변경 시 저장된 값 초기화
    if (e.key.length === 1 || e.code === "Backspace" || e.code === "Delete") {
        activeAutoIndex = -1;
        savedInputValue = null;
        wasInKeywordArea = false;
        const autoCompleteButtons = Array.from(document.querySelectorAll('.Auto__Complete__Button'));
        autoCompleteButtons.forEach(btn => {
            const parent = btn.closest('.Auto__Complete__Wrap');
            if (parent) {
                parent.classList.remove('active');
            }
        });
        const modal = document.querySelector('.Search__Modal__ScrollWrap');
        if (modal) {
            modal.scrollTop = 0;
        }
        return;
    }
    if (e.code === "ArrowDown" || e.code === "Tab" || e.code === "ArrowUp") {
        e.preventDefault();
        const autoCompleteButtons = Array.from(document.querySelectorAll('.Auto__Complete__Button'));
        if (autoCompleteButtons.length === 0)
            return;
        // 처음 방향키를 누를 때만 현재 input 값을 저장
        if (activeAutoIndex === -1) {
            savedInputValue = $input.value;
        }
        if (e.code === "ArrowDown" || e.code === "Tab") {
            if (activeAutoIndex < autoCompleteButtons.length - 1) {
                activeAutoIndex++;
            }
            else {
                activeAutoIndex = autoCompleteButtons.length - 1;
            }
        }
        else if (e.code === "ArrowUp") {
            if (activeAutoIndex > 0) {
                activeAutoIndex--;
            }
            else {
                // 최상단으로 올라갈 때
                activeAutoIndex = -1;
                // 모든 active 클래스 제거
                const allAutoCompleteWraps = document.querySelectorAll('.Auto__Complete__Wrap');
                allAutoCompleteWraps.forEach(wrap => {
                    wrap.classList.remove('active');
                });
                if (savedInputValue !== null) {
                    $input.value = savedInputValue;
                    setInputValue(savedInputValue);
                    const inputEvent = new Event('input', { bubbles: true, cancelable: true });
                    $input.dispatchEvent(inputEvent);
                }
                $input.focus();
                return;
            }
        }
        // 활성화된 항목 표시 업데이트
        autoCompleteButtons.forEach(btn => {
            const parent = btn.closest('.Auto__Complete__Wrap');
            if (parent) {
                parent.classList.remove('active');
            }
        });
        const activeButton = autoCompleteButtons[activeAutoIndex];
        const parent = activeButton.closest('.Auto__Complete__Wrap');
        if (parent) {
            parent.classList.add('active');
            // 스크롤 처리
            const modal = document.querySelector('.Search__Modal__ScrollWrap');
            if (modal) {
                const modalRect = modal.getBoundingClientRect();
                const parentRect = parent.getBoundingClientRect();
                if (parentRect.bottom > modalRect.bottom) {
                    modal.scrollTop += parentRect.bottom - modalRect.bottom;
                }
                else if (parentRect.top < modalRect.top) {
                    modal.scrollTop -= modalRect.top - parentRect.top;
                }
            }
        }
        // input 값 업데이트
        const mainName = activeButton.getAttribute("data-main-name");
        const isKeyword = activeButton.getAttribute("data-is-keyword") === "true";
        if (isKeyword) {
            wasInKeywordArea = true;
            if (mainName) {
                $input.value = mainName;
                setInputValue(mainName);
                const inputEvent = new Event('input', { bubbles: true, cancelable: true });
                $input.dispatchEvent(inputEvent);
            }
        }
        else {
            // 키워드 영역을 벗어났을 때 저장된 값으로 복구
            if (wasInKeywordArea && savedInputValue !== null) {
                $input.value = savedInputValue;
                setInputValue(savedInputValue);
                const inputEvent = new Event('input', { bubbles: true, cancelable: true });
                $input.dispatchEvent(inputEvent);
            }
        }
        $input.focus();
        return;
    }
    if (e.code === "Enter") {
        e.preventDefault();
        const activeButton = document.querySelector('.Auto__Complete__Wrap.active .Auto__Complete__Button');
        if (activeButton) {
            const isKeyword = activeButton.getAttribute("data-is-keyword") === "true";
            if (isKeyword) {
                const mainName = activeButton.getAttribute("data-main-name");
                if (mainName) {
                    $input.value = mainName;
                    setInputValue(mainName);
                    const inputEvent = new Event('input', { bubbles: true, cancelable: true });
                    $input.dispatchEvent(inputEvent);
                    setTimeout(() => {
                        const searchButton = document.querySelector('.search');
                        if (searchButton) {
                            searchButton.click();
                        }
                    }, 0);
                }
            }
            else {
                activeButton.click();
            }
        }
        else {
            const searchButton = document.querySelector('.search');
            if (searchButton) {
                searchButton.click();
            }
        }
        return;
    }
};
exports.onInputKeyDown = onInputKeyDown;
const onAutoCompKeyDown = (e) => {
    if (e.nativeEvent.isComposing) {
        return;
    }
    const anchorList = document.querySelectorAll(".Auto__Complete__Button");
    if (e.code === "ArrowLeft" || e.code === "ArrowRight") {
        e.preventDefault();
        const $input = document.body.querySelector("input");
        $input?.focus();
        return;
    }
    if (e.code === "ArrowUp") {
        e.preventDefault();
        const currentTabIdx = e.currentTarget.getAttribute("tabIndex");
        if (currentTabIdx === "0") {
            const $input = document.body.querySelector("input");
            $input?.focus();
            return;
        }
        if (currentTabIdx) {
            anchorList[Number(currentTabIdx) - 1].focus();
        }
    }
    if (e.code === "ArrowDown" || e.code === "Tab") {
        e.preventDefault();
        const currentTabIdx = e.currentTarget.getAttribute("tabIndex");
        if (currentTabIdx && anchorList[Number(currentTabIdx) + 1]) {
            anchorList[Number(currentTabIdx) + 1].focus();
        }
    }
};
exports.onAutoCompKeyDown = onAutoCompKeyDown;
const onRecentKeyDown = (e) => {
    if (e.nativeEvent.isComposing) {
        return;
    }
    const $Recent = document.body.querySelector(".Recent__List__Box");
    const $List = $Recent?.children;
    if (!$List)
        return;
    if (e.code === "ArrowLeft" || e.code === "ArrowRight") {
        e.preventDefault();
        const $input = document.body.querySelector("input");
        $input?.focus();
        return;
    }
    if (e.code === "ArrowUp") {
        e.preventDefault();
        const currentTabIdx = e.currentTarget.getAttribute("tabIndex");
        if (currentTabIdx === "0") {
            const $Arround = document.body.querySelector(".Search__Arround__Button");
            $Arround?.focus();
            return;
        }
        if (currentTabIdx) {
            const $target = $List[Number(currentTabIdx) - 1].children[0];
            $target.focus();
        }
    }
    if (e.code === "ArrowDown" || e.code === "Tab") {
        e.preventDefault();
        const currentTabIdx = e.currentTarget.getAttribute("tabIndex");
        if (currentTabIdx && $List[Number(currentTabIdx) + 1]) {
            const $target = $List[Number(currentTabIdx) + 1].children[0];
            $target.focus();
        }
    }
};
exports.onRecentKeyDown = onRecentKeyDown;
